import React from "react";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import rtlPlugin from "stylis-plugin-rtl";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SelfService from "./pages/SelfService";
import {
  ElectricityPlanThankYou,
  ELECTRICITY_PLAN_THANK_YOU_PATH,
} from "./pages/ElectricityPlanThankYou";
//import GasInvoicePayment from "./pages/GasInvoicePayment";
import theme from "./theme/theme";

const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [rtlPlugin],
  // prepend: true, // (optional) ensure MUI styles win in the head
});

function App() {
  return (
    <CacheProvider value={cacheRtl}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<SelfService />} />
            <Route
              path={ELECTRICITY_PLAN_THANK_YOU_PATH}
              element={<ElectricityPlanThankYou />}
            />

            {/* Deep-link route: e.g. /service-termination */}
            <Route path="/:serviceSlug" element={<SelfService />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </CacheProvider>
  );
}

export default App;
